import { render, staticRenderFns } from "./SiteArea.vue?vue&type=template&id=97fab2c6&"
import script from "./SiteArea.vue?vue&type=script&lang=ts&"
export * from "./SiteArea.vue?vue&type=script&lang=ts&"
import style0 from "./SiteArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
